/**
 * Decimal-place limit for carbon data inputs. Keep in step with the backend's
 * `@Digits(fraction = 5)` on the questionnaire DTOs and the rounding applied to
 * Excel template imports (`Cell.getBigDecimalValue(int)`).
 */
export const MAX_DECIMAL_PLACES = 5;

/** `step` for `<input type="number">`: the browser rejects finer values on submit. */
export const DECIMAL_STEP = `0.${"0".repeat(MAX_DECIMAL_PLACES - 1)}1`;

/** A positive number with at most MAX_DECIMAL_PLACES decimals. */
export const POSITIVE_NUMBER_REGEX = new RegExp(`^(?=.*[1-9])\\d*(?:\\.\\d{1,${MAX_DECIMAL_PLACES}})?$`);

/**
 * True when a value carries more decimals than MAX_DECIMAL_PLACES. Empty values
 * never exceed it — "required" is a separate check.
 */
export const exceedsMaxDecimals = (value) => {
  if (value === "" || value === null || value === undefined) return false;
  const match = String(value).trim().match(/\.(\d+)$/);
  return !!match && match[1].length > MAX_DECIMAL_PLACES;
};
